import { Component, OnInit } from '@angular/core';
import { RoleNameEnum } from 'src/app/admin-panel/enums/role-name.enum';
import { UserModel } from 'src/app/share-modul/models/user/user.model';
import { AuthenticationService } from 'src/app/share-modul/services/authentication/authentication.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-no-venues',
  templateUrl: './no-venues.component.html',
  styleUrls: ['./no-venues.component.scss']
})
export class NoVenuesComponent implements OnInit {

  user: UserModel | null;

  constructor( private authenticationService: AuthenticationService    ) {
  }

  ngOnInit(): void {
    this.authenticationService.loginUser.subscribe(user => this.user = user)
  }

  isUserGMN(){
    if(this.user?.roles.includes(RoleNameEnum.PosGeneralManager)){
      return true;
    } 
    return false;
  }
  redirectToSocialliteManager(){
    const search = '/';
    const replaceWith = '%2F';
    let refreshToken = localStorage.getItem("refresh_token");
    if(refreshToken){
       const result = (localStorage.getItem("refresh_token") as string).split(search).join(replaceWith);
       window.location.href = environment.URLSocialiteManager+"/login/"+result;
    }
  }

}
